const slideOffset = 16;
const slidesPerViewPort = 2;
const carousel = document.querySelector('.js-carousel1');
const carouselScroller = carousel.querySelector('.js-carousel-scroller1');
const carouselSlideSize = carouselScroller.querySelector('.js-carousel-slide1').clientWidth;
const nextButtonElement = carousel.querySelector('.js-next1');
const prevButtonElement = carousel.querySelector('.js-prev1');

nextButtonElement.addEventListener('click', scrollToNextPage);
prevButtonElement.addEventListener('click', scrollToPrevPage);
carouselScroller.addEventListener('scroll', handleScroll);

function handleScroll() {
  // @TODO PERFORM FIX
  if(carouselScroller.scrollLeft <= 30) {
  prevButtonElement.classList.add('is-hidden1');
} else if (carouselScroller.scrollLeft + carouselSlideSize * 2 + slideOffset * slidesPerViewPort === carouselScroller.scrollWidth) {
  nextButtonElement.classList.add('is-hidden1');
} else {
  prevButtonElement.classList.remove('is-hidden1');
  nextButtonElement.classList.remove('is-hidden1');
}
}


function scrollToNextPage() {
  carouselScroller.scrollTo({
    left: carouselScroller.scrollLeft + carouselSlideSize,
    behavior: 'smooth'
  });

  prevButtonElement.classList.remove('is-hidden1');

  if (hideNextArrow()) {
    nextButtonElement.classList.add('is-hidden1');
  } else {
    nextButtonElement.classList.remove('is-hidden1');
  }
}

function scrollToPrevPage() {
  carouselScroller.scrollTo({
    left: carouselScroller.scrollLeft - carouselSlideSize,
    behavior: 'smooth'
  });

  if (hidePrevArrow()) {
    prevButtonElement.classList.add('is-hidden1');
  } else {
    prevButtonElement.classList.remove('is-hidden1');
  }

  nextButtonElement.classList.remove('is-hidden1');
}

const hideNextArrow = () => {
  const totalSlidesOffset = slideOffset * slidesPerViewPort;

  return carouselScroller.scrollLeft + (carouselSlideSize * (slidesPerViewPort + 1)) + totalSlidesOffset >= carouselScroller.scrollWidth;
};

const hidePrevArrow = () => {
  return carouselScroller.scrollLeft <= carouselSlideSize + slideOffset;
};
